import { Card, TablePagination } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AddDialog } from "../../components/component/modals/AddModal";
import { Shadow } from "../../routers";
import { headCells } from "../../sections/news/headCells";
import EnhancedTable from "../../sections/projects/PageTable";
import Form from "../../sections/projects/ProjectForm";

export default function Projects() {
  // TODO: hooks

  // TODO: useStates
  const [openAdd, setOpenAdd] = useState(false);
  const [pagination, setPagination] = useState({
    page: 0,
    limit: 10,
  });
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(false);

  // TODO: get the data from slice
  const pages = useSelector((state) => state.project.projects);

  // TODO: fetching the pages
  // TODO: fetch the colors when searached

  // TODO: set the rows

  useEffect(() => {
    const data = pages?.data?.map((page) => ({
      id: page?.id,
      title: page?.title,
      thumbnail: page?.thumbnail,
      image: page?.image,
      province: page?.province,
      district: page?.district,
      description: page?.description,
      createdDate: moment(page?.createdAt)
        .format("Do MMMM, YYYY")
        .replace(/(\d+)(th|st|nd|rd)/, "$1$2"),
    }));

    setRows(data);
  }, [pages]);

  // TODO: functions
  const handleChangePage = (event, newPage) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination((prev) => ({
      ...prev,
      page: 0,
      limit: parseInt(event.target.value, 10),
    }));
  };

  // TODO: console.logs
  return (
    <>
      <Shadow>
        <Card color="transparent" shadow={false}>
          <EnhancedTable
            showSearch={false}
            title="Project"
            headCells={headCells}
            rows={rows}
            showFilter={false}
            setOpenAdd={() => setOpenAdd((prev) => !prev)}
            page={pagination.page}
            rowsPerPage={pagination.limit}
            search={search}
            setSearch={setSearch}
            refresh={refresh}
            setRefresh={setRefresh}
          />

          {/* TODO: pagination */}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={pages?.meta?.total}
            rowsPerPage={pagination.limit}
            page={pagination.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Shadow>

      {/* TODO: add pages */}
      <AddDialog
        maxWidth="lg"
        title={"Add new Project"}
        open={openAdd}
        handleClose={() => setOpenAdd(false)}
      >
        <Form handleClose={() => setOpenAdd(false)} />
      </AddDialog>
    </>
  );
}
